import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
const dataInicial = {
    informacionDetalle: []
}

const ADD_CERTIFICADO_EXPORTACION = 'ADD_CERTIFICADO_EXPORTACION'
const GET_FC_09_DETALLE_OC = 'GET_FC_09_DETALLE_OC'
const ACTUALIZAR_ARCHIVO_OC_FC09_EXITO = 'ACTUALIZAR_ARCHIVO_OC_FC09_EXITO'
const ADD_REVISION_DECISION = 'ADD_REVISION_DECISION'

export const obtenerFC_09Detalle = createAsyncThunk(
    GET_FC_09_DETALLE_OC,
    async (id) => {
        try {
            const fullUrl = host + `SolicitudFC09_OC/obtenerFC_09Detalle/${id}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const generarCertificadoExportacion = createAsyncThunk(
    ADD_CERTIFICADO_EXPORTACION,
    async (data) => {
        try {
            let fullUrl = host
            if (data.idioma == 'Español' && data.certificado=='Exportacion') fullUrl +=await  `SolicitudFC09_OC/generarCertificadoExportacionEspanol`
            if (data.idioma == 'Ingles' && data.certificado=='Exportacion') fullUrl += await `SolicitudFC09_OC/generarCertificadoExportacionIngles`
            if (data.idioma == 'Español' && data.certificado=='Promocion') fullUrl += await `SolicitudFC09_OC/generarCertificadoExportacionPromocion`
            if (data.idioma == 'Ingles' && data.certificado=='Promocion') fullUrl += await `SolicitudFC09_OC/generarCertificadoExportacionIngles`
            /*fullUrl = host + `SolicitudFC09_OC/generarCertificadoExportacionPromocion`*/
            delete data.certificado
            const res = await axios.post(fullUrl, data)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const generarRevisionDecision = createAsyncThunk(
    ADD_REVISION_DECISION,
    async (data) => {
        try {
            const fullUrl = host + `SolicitudFC09_OC/generarRevisionDecision`

            const res = await axios.post(fullUrl, data)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const actualizarFileOCFC_09 = createAsyncThunk(
    ACTUALIZAR_ARCHIVO_OC_FC09_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await actualizarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const actualizarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexo)
    formData.append('idSolicitudFK', data.idAnexoFK)
    const resFile = await axios.put(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}

export const metodosSolicitudFC09Slice = createSlice({

    name: 'metodosSolicitudFC09Slice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [obtenerFC_09Detalle.fulfilled]: (state, { payload }) => {
            state.informacionDetalle = payload
        },
    },

})


export const { } = metodosSolicitudFC09Slice.actions
export const SolicitudesFC09_OCReducer = metodosSolicitudFC09Slice.reducer